import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { InputBase } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import SearchIcon from '@material-ui/icons/Search';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import { noop } from 'Helpers/PropTypes';
import { getBorder } from 'Components/utils';
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = buildUseStyles('SearchInput', (theme) => ({
  root: {
    minHeight: theme.spacing(4.5),
    margin: 0,
    borderRadius: theme.spacing(3),
    minWidth: theme.dimensions.xs,
    flexGrow: 0,
    padding: theme.spacing(0, 1),
    '& > input': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.subtitle2.fontSize,
    },
    '& > input::placeholder': {
      opacity: 1,
    },
    ...getBorder(theme, { all: true, width: 1, color: fade(theme.palette.primary.main, 0.5) }),
  },
  searchIcon: {
    height: theme.spacing(2.5),
    margin: theme.spacing(0, 1, 0, 0.5),
  },
}));
const SearchInput = ({
  className,
  label: placeholder,
  onChange,
  onSearch,
  disabled,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      onSearch(event);
    }
  };

  return (
    <InputBase
      className={classNames(className, classes.root)}
      placeholder={placeholder}
      variant={'outlined'}
      disabled={disabled}
      startAdornment={<Icon icon={SearchIcon} className={classes.searchIcon} />}
      onChange={(val) => onChange(val)}
      onKeyDown={(event) => handleKeyDown(event)}
      inputProps={{
        className: classes.input,
      }}
    />
  );
};

SearchInput.defaultProps = {
  className: '',
  onChange: noop,
  onSearch: noop,
  disabled: false,
};

SearchInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SearchInput;
